<template>
  <div class="container">
    <div v-if="loading">
      <ophq-loading />
    </div>
    <div v-else>
      <v-alert v-if="erreur" type="error" text class="my-4">
        Le chargement de vos sociétés a échoué. Veuillez réessayer dans quelques instants et contacter l'Ordre si le problème persiste.
      </v-alert>
      <p v-else-if="societes.length === 0"><ressource code="aucune_societe" /></p>
      <div v-else>
        <v-text-field
          outlined
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          :label="getRessource('filtrer_par_nom_neq_adresse_representant')"
        />
        <v-data-table :items="filteredSocietes" :headers="headers">
          <template v-slot:item.voir="{ item }">
            <v-btn fab x-small @click="rowClicked(item)" color="primary" target="_blank" class="my-4"
              ><v-icon dark>mdi-eye</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.modifier="{ item }">
            <v-btn small v-if="item.lienModification" :href="item.lienModification" color="primary" target="_blank" class="my-4"
              ><ressource code="modifier_societe"
            /></v-btn>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/plugins/api"
import RessourcesHelpers from "@/components/ui/mixins/RessourcesHelpers"
export default {
  mixins: [RessourcesHelpers],
  data() {
    return {
      loading: false,
      erreur: false,
      societes: [],
      selected: null,
      search: ""
    }
  },
  mounted() {
    this.fetchSocietes()
  },
  computed: {
    headers() {
      return [
        { value: "voir" },
        { value: "nom", text: this.getRessource("info_nom") },
        { value: "neq", text: this.getRessource("info_neq") },
        { value: "formeJuridique", text: this.getRessource("info_formeJuridique") },
        { value: "representant", text: this.getRessource("info_representant") },
        { value: "adresse", text: this.getRessource("info_adresse") },
        { value: "modifier" }
      ]
    },
    filteredSocietes() {
      if (!this.search) {
        return this.societes
      } else {
        return this.societes.filter(
          (x) => this.filterBy(x, "nom") || this.filterBy(x, "neq") || this.filterBy(x, "adresse") || this.filterBy(x, "representant")
        )
      }
    }
  },
  methods: {
    // neq, adresse et representant sont nullables : sans le ?? la recherche leve une TypeError
    filterBy(item, property) {
      return (item[property] ?? "").toLowerCase().includes(this.search.toLowerCase())
    },
    fetchSocietes() {
      if (!this.$route.query.token) {
        return
      }
      const token = this.$route.query.token.replace(/\s/g, "+")
      const encodedToken = encodeURIComponent(token)
      this.loading = true
      this.erreur = false
      Api.get(`/contacts/mes-societes?token=${encodedToken}`)
        .then((res) => (this.societes = res.data))
        .catch(() => (this.erreur = true))
        .finally(() => (this.loading = false))
    },
    rowClicked(item) {
      this.$router.push({ name: `DetailSociete`, params: { id: item.id, societes: this.societes }, query: { ...this.$route.query } })
    }
  }
}
</script>

<style>
</style>